import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../components/SafeIcon';
import { FiCalendar, FiMapPin, FiClock, FiZap, FiPlus } from 'react-icons/fi';
import { weekendRoutes } from '../data/mockData';

const Planner = () => {
  return (
    <div className="max-w-6xl mx-auto space-y-8 pb-20 md:pb-0">
      <header className="mb-8">
        <h1 className="text-2xl font-bold text-white mb-2 flex items-center">
          <SafeIcon icon={FiCalendar} className="mr-3 text-transit-neon" />
          ROUTING_MODULE
        </h1>
        <p className="text-gray-400 font-mono text-sm">Configure your exploration vectors for the upcoming cycle.</p>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Route Cards */}
        <div className="lg:col-span-2 space-y-4">
          <div className="flex justify-between items-center border-b border-asphalt-700 pb-2">
             <h2 className="text-lg font-mono text-amber-500">SUGGESTED_VECTORS</h2>
             <button className="text-xs font-mono text-transit-neon flex items-center hover:text-white transition-colors">
               <SafeIcon icon={FiPlus} className="mr-1" /> CUSTOM_ROUTE
             </button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {weekendRoutes.map((route, idx) => (
              <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: idx * 0.1 }}
                key={route.id}
                className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-5 hover:border-transit-500/50 transition-all group relative overflow-hidden"
              >
                {/* Tech background decoration */}
                <div className="absolute -right-4 -top-4 w-24 h-24 bg-transit-500/5 rounded-full blur-xl group-hover:bg-transit-500/20 transition-all pointer-events-none" />
                
                <h3 className="text-lg font-bold text-white mb-3 group-hover:text-transit-neon transition-colors relative z-10">{route.title}</h3>
                
                <div className="grid grid-cols-2 gap-y-3 gap-x-2 text-sm font-mono text-gray-400 relative z-10">
                  <div className="flex items-center">
                    <SafeIcon icon={FiMapPin} className="mr-2 text-amber-500" />
                    {route.stops} STOPS
                  </div>
                  <div className="flex items-center">
                    <SafeIcon icon={FiClock} className="mr-2 text-transit-400" />
                    {route.duration}
                  </div>
                  <div className="flex items-center col-span-2">
                    <SafeIcon icon={FiZap} className="mr-2 text-red-400" />
                    INTENSITY: <span className="text-white ml-2">{route.intensity}</span>
                  </div>
                </div>

                <button className="mt-4 w-full py-2 bg-asphalt-700 text-xs font-mono text-white rounded group-hover:bg-transit-600 transition-colors relative z-10">
                  EXECUTE_ROUTE
                </button>
              </motion.div>
            ))}
          </div>
        </div>

        {/* Weekend Planner Timeline */}
        <div className="space-y-4">
          <h2 className="text-lg font-mono text-amber-500 border-b border-asphalt-700 pb-2">
            TIMELINE_SEQ
          </h2>
          <div className="bg-asphalt-800 border border-asphalt-600 rounded-lg p-4">
            <div className="relative pl-4 border-l border-asphalt-600 space-y-6">
               
               <div className="relative">
                 <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-transit-neon shadow-[0_0_8px_#00E5FF]" />
                 <p className="text-xs font-mono text-transit-neon mb-1">T-MINUS 2H</p>
                 <div className="bg-asphalt-700 rounded p-3 text-sm">
                   <p className="text-white font-medium">Link up at Transit Hub</p>
                   <p className="text-gray-400 text-xs mt-1">Awaiting 2 members...</p>
                 </div>
               </div>

               <div className="relative">
                 <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-amber-500" />
                 <p className="text-xs font-mono text-amber-500 mb-1">T-PLUS 1H</p>
                 <div className="bg-asphalt-700/50 border border-asphalt-600 rounded p-3 text-sm border-dashed">
                   <p className="text-gray-400 font-medium">+ Add Location Data</p>
                 </div>
               </div>

               <div className="relative">
                 <div className="absolute -left-[21px] top-1 w-3 h-3 rounded-full bg-asphalt-500" />
                 <p className="text-xs font-mono text-gray-500 mb-1">T-PLUS 4H</p>
                 <div className="bg-asphalt-700/30 rounded p-3 text-sm text-gray-500">
                   <p>System offline...</p>
                 </div>
               </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Planner;